import { render, staticRenderFns } from "./PremiumStatus.vue?vue&type=template&id=cb38a724&scoped=true"
import script from "./PremiumStatus.vue?vue&type=script&lang=js"
export * from "./PremiumStatus.vue?vue&type=script&lang=js"
import style0 from "./PremiumStatus.vue?vue&type=style&index=0&id=cb38a724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb38a724",
  null
  
)

export default component.exports